import { ExternalLink } from "lucide-react";
// import { Button } from "../../../components/ui/button";
import { Card, CardContent, CardTitle } from "../../../components/ui/card";

const Knowledgebase = () => {
  return (
    <div className="w-full flex items-center justify-center ">
      <Card className="max-w-4xl overflow-hidden p-3">
        <CardTitle className="text-md mb-2 flex justify-center w-full items-center">
          Knowledgebase
        </CardTitle>

        <CardContent className="p-3 pt-2">
          <p>
            The AML/CTF Rules 2025 set out Australia’s regulatory framework to
            prevent money laundering and terrorism financing. They provide
            guidance on customer due diligence, reporting obligations, risk
            management, and compliance requirements for businesses under the
            AML/CTF Act.
          </p>
          <p className="mt-2">
            To support risk assessment and compliance obligations, the following
            international and regulatory resources should also be considered:
          </p>
          <ol className="list-decimal pl-4 pt-2">
            <li className="mb-2">
              FATF High-Risk Jurisdictions (Black & Grey Lists) Countries listed
              under the Financial Action Task Force (FATF) Black List and Grey
              List are considered High Risk by default. These jurisdictions are
              subject to increased monitoring due to deficiencies in their
              AML/CTF frameworks.
              <div className="mt-2 flex items-center gap-2">
                <span className="font-bold">Reference:</span>{" "}
                <a
                  href={
                    "https://www.fatf-gafi.org/en/countries/black-and-grey-lists.html"
                  }
                  target="_blank"
                  className="inline-flex items-center rounded-lg bg-webPrimary px-2 py-1 text-sm font-medium text-white hover:bg-primary/90 dark:hover:bg-webSecondary transition-colors"
                  rel="noreferrer"
                >
                  Black and Grey List <ExternalLink className="h-4 w-4 ml-2" />
                </a>
              </div>
            </li>

            <li className="mb-2">
              Basel AML Index If a country is not listed on the FATF Black or
              Grey list, but its Basel AML Index risk rating is higher than 5,
              it should also be treated as High Risk.
              <div className="mt-2 flex items-center gap-2">
                <span className="font-bold">Reference:</span>{" "}
                <a
                  href={"https://index.baselgovernance.org/ranking"}
                  target="_blank"
                  className="inline-flex items-center rounded-lg bg-webPrimary px-2 py-1 text-sm font-medium text-white hover:bg-primary/90 dark:hover:bg-webSecondary transition-colors"
                  rel="noreferrer"
                >
                  Basel List <ExternalLink className="h-4 w-4 ml-2" />
                </a>
              </div>
            </li>

            <li>
              AUSTRAC Risk Assessment Guidance AUSTRAC provides practical
              guidance to assist businesses in conducting Money Laundering and
              Terrorism Financing (ML/TF) risk assessments and implementing
              appropriate compliance frameworks.
              <div className="mt-2 flex items-center gap-2">
                <span className="font-bold">Reference:</span>{" "}
                <a
                  href={
                    "https://www.austrac.gov.au/sites/default/files/2026-01/Quick-guide-MLTF-risk-assessment-framework-%20accountants-January-2026.pdf"
                  }
                  target="_blank"
                  className="inline-flex items-center rounded-lg bg-webPrimary px-2 py-1 text-sm font-medium text-white hover:bg-primary/90 dark:hover:bg-webSecondary transition-colors"
                  rel="noreferrer"
                >
                  AUSTRAC Link <ExternalLink className="h-4 w-4 ml-2" />
                </a>
              </div>
              <p className="my-4 -ml-4">
                These sources should be used together when assessing
                jurisdictional risk and determining appropriate AML/CTF
                controls.
              </p>
            </li>

            <li>
              Real Estate Sector Document Library:
              <div className="my-2 flex items-center gap-2">
                {/* <span className="font-bold">Reference:</span>{" "} */}
                <a
                  href={
                    "https://www.austrac.gov.au/reforms/program-starter-kits/real-estate-guidance/real-estate-program-starter-kit/real-estate-program-starter-kit-document-library"
                  }
                  target="_blank"
                  className="inline-flex items-center rounded-lg bg-webPrimary px-2 py-1 text-sm font-medium text-white hover:bg-primary/90 dark:hover:bg-webSecondary transition-colors"
                  rel="noreferrer"
                >
                  https://www.austrac.gov.au/reforms/program-starter-kits/real-estate-guidance/real-estate-program-starter-kit/real-estate-program-starter-kit-document-library
                </a>
              </div>
            </li>

            <li>
              Legal Profession Document Library:
              <div className="my-2 flex items-center gap-2">
                {/* <span className="font-bold">Reference:</span>{" "} */}
                <a
                  href={
                    "https://www.austrac.gov.au/reforms/program-starter-kits/legal-profession-guidance/legal-profession-program-starter-kit/legal-profession-program-starter-kit-document-library"
                  }
                  target="_blank"
                  className="inline-flex items-center rounded-lg bg-webPrimary px-2 py-1 text-sm font-medium text-white hover:bg-primary/90 dark:hover:bg-webSecondary transition-colors"
                  rel="noreferrer"
                >
                  https://www.austrac.gov.au/reforms/program-starter-kits/legal-profession-guidance/legal-profession-program-starter-kit/legal-profession-program-starter-kit-document-library
                </a>
              </div>
            </li>

            <li>
              Jeweller Program Document Library:
              <div className="mt-2 flex items-center gap-2">
                {/* <span className="font-bold">Reference:</span>{" "} */}
                <a
                  href={
                    "https://www.austrac.gov.au/reforms/program-starter-kits/dealers-precious-metals-stones-and-products-guidance/jeweller-program-starter-kit/jeweller-program-starter-kit-document-library"
                  }
                  target="_blank"
                  className="inline-flex items-center rounded-lg bg-webPrimary px-2 py-1 text-sm font-medium text-white hover:bg-primary/90 dark:hover:bg-webSecondary transition-colors"
                  rel="noreferrer"
                >
                  https://www.austrac.gov.au/reforms/program-starter-kits/dealers-precious-metals-stones-and-products-guidance/jeweller-program-starter-kit/jeweller-program-starter-kit-document-library
                </a>
              </div>
            </li>
          </ol>

          {/* <a
            href="https://www.austrac.gov.au/amlctf-reform/reforms-guidance/before-you-start/new-industries-and-services-be-regulated-reform/professional-services-reform"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button className="w-fit mt-4">Learn More</Button>
          </a> */}
        </CardContent>
      </Card>
    </div>
  );
};

export default Knowledgebase;
